class EndpointMapController {
    constructor($log, $scope, $rootScope, $timeout, $interval, NgMap, endpointModel, locationService, channelModel, userService, privateCallService) {
        this.scope = $scope;
        if (!$scope.elementId)
            throw new Error("must provide 'elementId' scope param - it will used as the html element id for the ng-map component");
        this.elementId = $scope.elementId;
        this.map = undefined; // initialized in 'init'
        this.mapRightclickListener = null;

        this.log = $log;
        this.timeout = $timeout;
        this.interval = $interval;
        this.NgMap = NgMap;
        this.locationService = locationService;
        this.privateCallService = privateCallService;
        this.endpointModel = endpointModel;
        this.myEndpoint = endpointModel.getMyEndpoint();
        this.channelModel = channelModel;
        this.userService = userService;

        this.endpoints = this.scope.endpoints = endpointModel.getChannelEndpoints(this.channelId);
        this.centerOn = "[ 41.850033, -87.6500523 ]"; // Default center of United States
        this.zoom = 3;

        var mapDisabled = false;

        var unbindEndpointsLoaded = $scope.$on('endpointModel.endpointsLoaded', (e, channelEndpoints) => {
            this.endpoints = this.scope.endpoints = channelEndpoints;
            //this.log.log("endpoints updated on " + this.elementId, this.endpoints);
        });

        var unbindSharingLocation = $scope.$on('locationService.sharingLocation', (e, endpoint) => {
            this.centerMapView();
        });

        var unbindLocationCentered = $rootScope.$on('presenceTableController.locationPinClicked', (e, location) => {
            this.centerZoomMapOnLoc(location);
        });

        var unbindEndpointsDisabledOnChannel = $rootScope.$on('endpointModel.endpointsDisabledOnChannel', (e, channelId) => {
            mapDisabled = true;
        });

        var unbindEndpointsEnabledOnChannel = $rootScope.$on('endpointModel.endpointsEnabledOnChannel', (e, channelId) => {
            if(mapDisabled) {
                this.init(this.elementId);
                mapDisabled = false;
            }
        });

        $scope.$on('$destroy', () => {
            unbindEndpointsEnabledOnChannel();
            unbindEndpointsDisabledOnChannel();
            unbindEndpointsLoaded();
            unbindSharingLocation();
            unbindLocationCentered();
            if(this.mapRightclickListener) {
                this.mapRightclickListener.remove();
            }

            this.log.debug(this.elementId + ' EndpointMapController destroyed');
        });

        this.init(this.elementId);
    }

    init(id) {
        this.enableConfirm = true;
        this.NgMap.getMap({ id: id }).then((evtMap) => {
            this.map = evtMap;

            // not going to lie - i don't know why this sequence of events is needed, but it works and seems to be required.
            google.maps.event.trigger(this.map, 'resize');
            this.scope.$emit('timeForResize');
            this.timeout(() => {
                window.dispatchEvent(new Event('resize'));
                this.initializeMap();
            }, 50);

        }).catch((err) => {
            this.log.error(id + ': Error getting map', err);
        });
    }

    initializeMap() {
        var self = this;
        this.log.debug(this.elementId + ' map initialized, resizing');
        this.map.customMarkers.confirm.setVisible(false);

        // Set up right-click menu to set location
        if (!this.mapRightclickListener) {
            this.mapRightclickListener = google.maps.event.addListener(this.map, 'rightclick', (e) => {
                if (self.locationService.isSharingEnabled) {
                    self.setLocationValue = e.latLng;
                    self.map.customMarkers.confirm.setVisible(true);
                    self.map.customMarkers.confirm.setPosition(e.latLng);
                }
            });
        }

        this.centerMapView();
    }

    centerMapView() {
        if (!this.locationService.isSharingEnabled) {
            this.fitAllEndpointsToBounds();
        } else {
            this.initiallyCenterOnSelfIfSharingLocation();
        }
    }

    fitAllEndpointsToBounds() {
        let endpoints = this.endpoints;
        if (endpoints.length === 0)
            this.log.warn('no endpoints to fit bounds');

        let latLngBounds = new google.maps.LatLngBounds();
        let latLng;
        endpoints.forEach(endpoint => {
            if (endpoint.location) {
                latLng = new google.maps.LatLng(endpoint.location.la, endpoint.location.lo);
                latLngBounds.extend(latLng);
                this.log.debug("added endpoint to bounds: ", endpoint.location.la, endpoint.location.lo);
            }
        });

        var center = latLngBounds.getCenter();
        if (center.lat() > 0) {
            this.log.debug(`setting $scope.centerOn to location: ${center.lat()}, ${center.lng()} ${typeof center.lat()}`);
            this.centerOn = `[ ${center.lat()}, ${center.lng()} ]`;
            this.map.fitBounds(latLngBounds);
        } else {
            this.log.warn("can't re-center for some reason - check the endpoints being added to the bounds.");
        }
    }

    initiallyCenterOnSelfIfSharingLocation(ep) {
        var endpoint = ep || this.myEndpoint; //endpointModel.getMyEndpoint();
        if (endpoint.location) {
            this.centerZoomMapOnLoc(endpoint.location);
        } else {
            this.log.warn('attempted to initialize map centered on self, but endpoint had no location value');
        }
    }

    centerZoomMapOnLoc(loc) {
        if (loc && this.map) {
            this.log.debug(`moving map center to location: ${loc.la}, ${loc.lo} ${typeof loc.la}`);
            this.map.setCenter({lat: parseFloat(loc.la), lng: parseFloat(loc.lo)});
            this.map.setZoom(13);
        }
    }

    showDetail(ep) {
        if (ep !== this.myEndpoint) {
            this.selectedEndpoint = ep;
            this.map.showInfoWindow('endpoint-info', ep.id);
        }
    }

    sameUser() {
        return this.selectedEndpoint.userName === this.myEndpoint.userName;
    }

    getFlags(channelId) {
        return this.selectedEndpoint.flags.get(channelId);
    }

    showPhoneIcon(channelId) {
        let flags = this.getFlags(channelId);
        let isSelf = flags && flags.Self;
        let onPhone = this.selectedEndpoint.disposition === 'Phone';
        let sameUser = this.sameUser();
        return !isSelf && !onPhone && !sameUser && this.myEndpoint.callAlias;
    }

    showChatIcon(channelId) {
        if(channelId <= 0) { // No point showing this if the endpoint is already in a private talkgroup
            return false;
        }

        let flags = this.getFlags(channelId);
        let isSelf = flags && flags.Self;
        let canChat = this.selectedEndpoint.privateTxtEnabled;
        let sameUser = this.sameUser();
        return !isSelf && !sameUser && canChat;
    }

    hideDetail() {
        this.map && this.map.hideInfoWindow('endpoint-info');
    }

    closeMaximizedMap() {
        this.hideDetail();
        this.scope.$emit('map.closeFullscreenMap');
    }

    get channelId() {
        var _selectedChannel = this.channelModel.getSelectedChannel();
        return _selectedChannel ? _selectedChannel.id : void 0;
    }

    okShareLocation() {
        this.locationService.setLocation(this.setLocationValue.lat(), this.setLocationValue.lng());
        this.map.customMarkers.confirm.setVisible(false);
    }

    cancelShareLocation() {
        this.map.customMarkers.confirm.setVisible(false);
    }

    openPrivateTalkgroup(endpoint, call) {
        var user = this.userService.getUser(endpoint.userName);
        this.channelModel.addOrUpdateAndSelectPrivateCallChannel(this.userService.getUser(this.myEndpoint.userName), user);

        if (call)
            this.callEndpoint(user);
        else
            this.closeMaximizedMap();
    }

    callEndpoint(user) {
        this.closeMaximizedMap();
        this.privateCallService
            .callRequest(user.callAlias, user.userName, user.name)
            .then((resp) => this.scope.$emit('makingCall', resp))
            .catch(err => this.log.error(err));
    }
}

angular.module('webcomm')
    .directive('endpointMap', ['$log', function($log) {
        return {
            restrict: 'EA',
            scope: {
                elementId: '@'
            },
            templateUrl: 'app/main/channel/map/endpointMap.html',
            replace: true,
            controller: 'endpointMapController',
            controllerAs: 'mapController'
        };
    }])
    .controller('endpointMapController', [
        '$log',
        '$scope',
        '$rootScope',
        '$timeout',
        '$interval',
        'NgMap',
        'endpointModel',
        'locationService',
        'channelModel',
        'userService',
        'privateCallService',
        EndpointMapController]);